















import { Vue, Component } from 'vue-property-decorator';

@Component
export default class DataPanel extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/DataPanel.vue